import { render, staticRenderFns } from "./AvaliationForm.vue?vue&type=template&id=773cf94f"
import script from "./AvaliationForm.vue?vue&type=script&lang=js"
export * from "./AvaliationForm.vue?vue&type=script&lang=js"
import style0 from "./AvaliationForm.vue?vue&type=style&index=0&id=773cf94f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports